import { useAuthContext, usePermissions } from '/src/hooks';
import { UPGRADE_REASONS } from './constants';
import { AUDIENCE_METADATA } from './metadata';
import { CAPABILITY_REASONS } from '../_global/constants';

function parseAllowedCriterias(criterias) {
  if (!criterias) {
    return [];
  }

  try {
    const parsedCriterias = JSON.parse(criterias);

    return Array.isArray(parsedCriterias) ? parsedCriterias : [];
  } catch {
    return [];
  }
}

export function useAllowedCriterias() {
  const permissions = usePermissions();
  const { capabilities } = useAuthContext();
  const parsedAllowedCriterias = parseAllowedCriterias(capabilities.audiences.allowedTargetingCriteria.criterias);
  const allowedTargetingCriterias = Object.fromEntries(
    Object.keys(AUDIENCE_METADATA).map((criteria) => [
      criteria,
      parsedAllowedCriterias.includes(criteria)
        ? { allowed: true }
        : { allowed: false, reason: UPGRADE_REASONS.AUDIENCE_UPGRADE },
    ]),
  );

  const allowedFilteringCriterias = Object.fromEntries(
    Object.entries(AUDIENCE_METADATA).map(([criteria, { filteringFeatureAccess }]) => {
      if (!filteringFeatureAccess) {
        return [criteria, { allowed: true }];
      }

      return [
        criteria,
        permissions.can(filteringFeatureAccess.permission, filteringFeatureAccess.feature).reason ===
        CAPABILITY_REASONS.UPGRADE
          ? {
              allowed: false,
              reason: UPGRADE_REASONS.FEATURE_UPGRADE,
              upsellModal: filteringFeatureAccess.upsellModal,
            }
          : { allowed: true },
      ];
    }),
  );

  return { allowedTargetingCriterias, allowedFilteringCriterias };
}
